<template>
  <div class="wx-img por dib vat ovh" :style="sizeStyle">
    <div class="wx-img-inner" :style="scale" v-if="notFollow">
      <wx-login :to="to"></wx-login>
    </div>
    <div class="wx-img-inner" :style="{width: size + 'px', height: size + 'px'}" v-else>
      <img v-show="src" @error="src = ''" @load="checkCode" :src="src" alt="" class="w100 h100 vat"/>
      <icon type="ios-loading abs-mc" :class="{loading: !src}" v-show="!src"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "WxImg",
    props: {
      to: {
        type: String,
        default: '',
      },
      size: {
        type: Number,
        default: 248
      },
      notFollow: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        innerWidth: 248,
        src: '',
        scene_id: '',
        timer: null,
      };
    },
    created() {
      this.getSrc();
    },
    methods: {
      using() {
        this.$emit('is-use', this);
      },
      checkCode() {
        if (this.scene_id) {
          this.http.NEWCheckCode({
            scene_id: this.scene_id,
          }).then(res => {
            this.GetWxInfoSucc(res);
            this.using();
          }).catch(err => {
            if (+err.code === 10004) {
              this.timer = setTimeout(() => {
                this.checkCode();
              }, 2000);
              return;
            } else if (+err.code === 10139) {
              this.GetWxInfoSucc(true, err);
            } else {
              this.$err(err);
            }
            this.using();
          });
        }
      },
      getSrc() {
        if (this.notFollow) return;
        this.src = '';
        this.http.NEWWxQrCode().then(res => {
          this.src = res.url;
          this.scene_id = res.scene_id;
        }).catch(this.$err);
      },
    },
    beforeDestroy() {
      clearTimeout(this.timer);
      this.timer = null;
    },
    computed: {
      scale() {
        return {
          transform: `scale(${this.proportion})`,
        };
      },
      proportion() {
        return this.size / this.innerWidth;
      },
      sizeStyle() {
        let {size} = this;
        size += 'px';
        return {
          width: size,
          height: size,
        }
      },
    },
  }
</script>

<style scoped lang="less">
  @keyframes load {
    0% {
      transform: translate(-50%, -50%) rotateZ(0);
    }
    100% {
      transform: translate(-50%, -50%) rotateZ(360deg);
    }
  }

  .wx-img-inner {
    transform-origin: top left;
    background-color: #efefef;
    .wx-login {
      transform: translate(-26px, -64px);
    }
  }

  .loading {
    font-size: 32px;
    animation: load .5s infinite;
  }
</style>